import { useUserStore } from '@/entities/user/model/userStore'

export const imageApi = {
  getUserStore: () => {return useUserStore()},

  getImageUrl(image: string|null) {
    const API_URL = window.APP_CONFIG.API_URL;
    const YANDEX_URL = window.APP_CONFIG.YANDEX_STORAGE_URL;

    if (image === null) {
      return API_URL + window.APP_CONFIG.DEFAULT_IMAGE;
    }

    if (image.startsWith('http')) {
      return image;
    }

    const user = this.getUserStore().user;

    if (user && user.settingsJson && user.settingsJson.useYandexStorage) {
      return YANDEX_URL + image;
    }
    return API_URL + image;
  },

  getDefaultImage() {
    const API_URL = window.APP_CONFIG.API_URL;
    const DEFAULT_IMAGE = window.APP_CONFIG.DEFAULT_IMAGE;
    return `${API_URL}${DEFAULT_IMAGE}`;
  }
};
